import React from 'react';
import { CoreTooltip } from '../components/Tooltip';

export function withTooltip<T>(componentName: string) {
  // WrappedComponent/props stay untyped (pre-existing HOC boundary); `T` is still explicit per call site so the ref keeps its real element type.
  return (WrappedComponent: any) => {
    const ComponentWithTooltip = React.forwardRef<T, any>((props, ref) => {
      if (props.tooltip) {
        const { content, placement } = props.tooltip;
        const computedProps = {
          ...(placement && { placement }),
        };

        return (
          <CoreTooltip hasArrow label={content} {...computedProps}>
            <WrappedComponent {...props} ref={ref} />
          </CoreTooltip>
        );
      }

      return <WrappedComponent {...props} ref={ref} />;
    });

    ComponentWithTooltip.displayName = `withTooltip(${componentName})`;

    return ComponentWithTooltip;
  };
}
